<button
  mat-menu-item
  [ngClass]="template.viewed ? null : 'pristine'"
  [routerLink]="template.routerLink || []"
>
  <h6>{{ template.name }}</h6>
  <p>{{ template.application }} &bull; {{ template.created }}</p>
</button>
